import { boardOf, colorToMove, inCheck, type BoardSquare, type Square, type State } from '@chessshooter/shared';

// What the renderer and the HUD read off the position, computed once per FEN: every call into the
// shared chess API loads chess.js from the FEN, which is too much for 60 frames a second.

export interface Position {
  fen: string;
  /** rank 8 first, as boardOf() returns it */
  board: BoardSquare[][];
  /** the side to move is in check … */
  check: boolean;
  /** … and this is its king, for the highlight */
  king: Square | null;
}

/** The position of `state`, or `previous` when it still describes the same FEN. */
export function positionOf(state: State, previous: Position | null = null): Position {
  const fen = state.chess.fen;
  if (previous !== null && previous.fen === fen) return previous;
  const board = boardOf(state);
  const color = colorToMove(state);
  let king: Square | null = null;
  for (const row of board) for (const cell of row) if (cell && cell.type === 'k' && cell.color === color) king = cell.square;
  return { fen, board, check: inCheck(state), king };
}

export function pieceAt(position: Position, square: Square): BoardSquare {
  for (const row of position.board) for (const cell of row) if (cell && cell.square === square) return cell;
  return null;
}
